/**
 * Created by Miguel on 23/05/2017
 */
 import { Component, OnInit,   } from '@angular/core';
 import {UserService} from "../../../services/user.service";
 import { AppDataService }  from '../../../services/app-data.service';
 import { CompanyService }  from '../../../services/company.service';
 import { NpcModalComponent }  from '../npc-modal/npc-modal-component';
 import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
 import { ItemBean } from '../../../beansts/item.bean';
 import { WalletService }  from '../../../services/wallet.services';
 import { TranslationService } from '../../../services/translation.service';

 declare var $ : any;
 declare var Swal: any
 
 @Component({
     selector : 'vendor-modal',
     templateUrl:'vendor-modal.html',
     providers  : [],  
 })
 export class VendorModal extends NpcModalComponent implements OnInit {
   public list;
   public containerList;
   public userCanEdit=false;
   public ground=false;
   public groundList;
   public groundName='Chão';
   public containerImg='/assets/game-ui/bag/bag.png'
 
   
   public coinsEarned=0;
   public buyerGold=0;
   public tell=false;
   public paint;
   public equipChanged={};
   public vendorName='Vendedor';
   public title='Clique para usar'

   public ctx;
   public canvas;
 
   public recipe;
 
   public voidImage
   public MAXQUANTITY=10;
   public gender='male';
   public skin ='rgb(255, 0, 0,.2)';
   public shirt='rgb(255, 0, 0,.6)';
   public pants='rgb(0, 0, 255,.2)';
   public head='rgb(0, 0, 0,1)'
   public shoes='rgb(0, 0, 0,1)';
   public bodyTypeUrl
   public headTypeUrl
   public chestTypeUrl
   public legsTypeUrl
   public feetTypeUrl
   public isContainer=false;
   public bufferImage;
   public bufferName;
   public avatar;
   public admin=true;
   public allLoaded=false;
 
     public ngOnInit() : any {
       this.list = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
       this.containerList = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
 
       if (!this._appData.userEventContainer){
         this._companyService.getUserContainerRef().get().then((cdata)=>{
             let clist= new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
            let i=0;
             cdata.forEach(c=>{
               let item=new ItemBean();
               item.parse(c.data())
               clist[i]=(item)
               i++
             })
             this._appData.userEventContainer=clist;
           })
 
       }
     }
 
     public reload(){

      this.npcDialog={welcome:'buscando',questions:[]}
      this._companyService.getNpcDialog(this._appData.npc.npcId).get().then(val=>{
        this.npcDialog=val.data();
        this._appData.npc=this.npcDialog;
        this._appData.npc.npcId=this.npcDialog.id;
        this.questions=this.npcDialog.questions;
        if (this._appData.npc.distance>400){
          Swal.fire({title:'Você está distante deste personagem',text:'Se aproxime do personagem para conversar com ele'})
          return;
        }
        this.dialog=this.npcDialog.welcome
        this.isContainer=false;
        //fill container
        this.change();
        if (this.npcDialog.owner==this._appData.instagramUser.uid){
          this.userCanEdit=true;
        }
        this.vendorName=this._appData.npc.name;
        $('#vendorModal').modal("show");  
        
      })
    }
     public swap(){
       this.isContainer=!this.isContainer
       if (this.isContainer){
         this.containerImg=this.npcDialog.thumbnail;
         this.vendorName=this.npcDialog.name;
 
       }
       else{
         this.containerImg='/assets/game-ui/bag/bag.png'
         this.vendorName='Mochila'
       }
     }
 

     public isNumber(n){
      return !isNaN(parseFloat(n)) && !isNaN(n - 0);
    }

     public clickContainerItem(item){
      //take item out of inventory to the container for selling
      $('#vendorModal').modal('hide')
      Swal.fire({
        title: 'Vender por qual valor?',
        text:'Descreva o valor (em livecoins) de venda deste produto',
        input: 'text',
        inputAttributes: {
        autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Vender',
        showLoaderOnConfirm: true,
      }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else if (result.value) {
            let cost=result.value
            if (this.isNumber(cost)){
              item.cost=parseFloat(cost);
     //         Swal.fire({title:"Aguarde",text:"Você está botando o item no vendedor...este processo pode levar alguns segundos por favor aguarde..."})
              /*this._walletService.makeTokenTransfer(this._appData.instagramUser.uid,'user',this.npcDialog.id,'npc',item.tokenId,1).subscribe(res=>{
                if (res.status==200){
                  Swal.fire({title:"Sucesso",text:"Seu item está disponível a venda neste vendedor pelo preço de "+cost+"."})                 */
                      this.containerList=this.containerList.filter((it)=>{
                        return (it.objectId!=item.objectId)
                      }) 
                      this._appData.userEventContainer=this._appData.userEventContainer.filter((it)=>{
                        return (it.objectId!=item.objectId)
                      }) 
                      this._companyService.getUserContainerRef().doc(item.objectId.toString()).delete();
                      this._companyService.getNpcDialog(this.npcDialog.id).collection("container").doc(item.objectId.toString()).set(item.toDB());
                      for (let i=0;i<this.list.length;i++){
                        if (this.list[i].quantity==0){
                          this.list[i]=item;
                          break;
                        }
                      }
                      $('#vendorModal').modal("show")
 /*                   }
                    else{
                      Swal.fire({title:this.translate.instant('FAIL'),text:"Ocorreu um erro ao tentarmos adicionar seu item para venda. Tente novamente."})                 
                    }
                  },err=>{
                    Swal.fire({title:this.translate.instant('FAIL'),text:"Ocorreu um erro ao tentarmos adicionar seu item para venda. Tente novamente."})                 
                  });*/
        
            }
            else{
              Swal.fire('Preço inválido','Você escolheu um valor que não é válido pra preço')
              $('#vendorModal').modal("show")
            }
    
          }
      });

   }
   public buyItem(item){

     let cost=Number(item.cost)
     let mygold=this.buyerGold;
     if (cost>mygold){
      Swal.fire({title:'Sem recursos',text:'Você possui $'+mygold+' livecoins e o produto custa $'+cost+' logo você não pode comprar.'});
     }
     else{
       Swal.fire({title:'Comprar '+item.name+' por $'+item.cost+' livecoins',
       text:'Você confirma que quer fazer essa compra',
       confirmButtonText: "Comprar",
       cancelButtonText:"Cancelar",
       showCloseButton: true,
       showCancelButton: true,
       focusConfirm: false, 
       }).then((result) => {
         if (result.dismiss=='backdrop') {}
         else if (result.dismiss=='close') {}
         else if (result.dismiss=='cancel'){}
         else{
           this.buyItem(item);
          Swal.fire({title:"Aguarde",text:"Você está recebendo o item do vendedor...este processo pode levar alguns segundos por favor aguarde..."})
          this._walletService.makePurchaseTransfer(this.npcDialog.owner,'user',this._appData.instagramUser.uid,'user',item.tokenId,1,item,this.npcDialog.id,'npcs',this._appData.instagramUser.uid,'user-container',cost).subscribe(res=>{
            if (res.status==200){
              for (let i=0;i<this.containerList.length;i++){
                if (!this.containerList) {
                  this.containerList = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
                }
                if (this.containerList[i].quantity=0){
                  this.containerList[i]=item
                }
              }
              this._appData.userEventContainer.push(item);
              this.list=this.list.filter((it)=>{
                  return (item.objectId!=it.objectId)
              })
  
            }
            else{
              Swal.fire({title:this.translate.instant('FAIL'),text:"Ocorreu um erro ao tentarmos adicionar fazer a venda...tente novamente."})                 
            }
          },err=>{
            Swal.fire({title:this.translate.instant('FAIL'),text:"Ocorreu um erro ao tentarmos adicionar fazer a venda...tente novamente."})                 
          }) 

        }
      })
    }
   }
   public recoverItem(item){
    Swal.fire({title:'Recuperar '+item.name,
    text:'Você confirma que deseja tirar esse item de venda?',
    confirmButtonText: "Recuperar",
    cancelButtonText:"Cancelar",
    showCloseButton: true,
    showCancelButton: true,
    focusConfirm: false, 
    }).then((result) => {
      if (result.dismiss=='backdrop') {}
      else if (result.dismiss=='close') {}
      else if (result.dismiss=='cancel'){}
      else{

    this._companyService.addToUserContainer(this._appData.instagramUser,item.toDB())
    for (let i=0;i<this.containerList.length;i++){
      if (!this.containerList) {
        this.containerList = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
      }
      if (this.containerList[i].quantity=0){
        this.containerList[i]
      }
    }
    this._appData.userEventContainer.push(item);
    this._companyService.getNpcDialog(this.npcDialog.id).collection('container').doc(item.objectId).delete().then(val=>{
        this.list=this.list.filter((it)=>{
          return (item.objectId!=it.objectId)
        })
      })
      }
    })
   }
   public clickItem(item){
      if (this.npcDialog.owner==this._appData.instagramUser.uid){
        this.recoverItem(item)
      }
      else{
        if (item.quantity==0){
          Swal.fire({title:'Erro',text:'Clique em um item a venda para comprá-lo.'});
          return 
        }
        this.buyItem(item)
      }
    }

     public closeModal(){
       $('#containerModal').modal('hide')
 
     }
 
     public change() {
      this.list = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})

      //checkout if i have a usercontainer and garantee all is ok with images
      if (!this._appData.userEventContainer){
        this._companyService.getUserContainer(true)
      }
      else{
        //check wallet
            this._walletService.getTokenBalance('user',this._appData.instagramUser.uid).subscribe(val=>{
              let vet=val.json();
              let lid=1;
              vet.forEach(element => {
                let address=element.mint_address
                let amount=element.ui_amount
                if (address==this.npcDialog.purchaseToken){
                  this.buyerGold=amount;
                }
                else if (address==this.npcDialog.sellToken){
                  this.containerList = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
                  let filt=this._appData.userEventContainer.filter(val=>{
                    return val.tokenId==address
                  })
                  if (filt){
                    let idx=0;                  
                    filt.forEach(it=>{
                      if (!it.equipped){
                        this.containerList[idx]=it;
                        idx++
                        amount--; 
                      }
                    }) 
                  }
                }
              });
            });;


        

      }

         

 
       if (this.npcDialog){
         //search the wallet
         this._walletService.getCreateWallet('npc',this.npcDialog.id).subscribe(val=>{
           if (val.status==200){
              //I have wallet created
                      //check wallet
            this.list = new Array(25).fill({'name':'vazio',thumbnail:'/assets/avatars/black.png',quantity:0})
            this._walletService.getTokenBalance('npc',this.npcDialog.id).subscribe(val=>{
              let vet=val.json();
              let sellQuantity=0
              vet.forEach(element => {
                let address=element.mint_address
                let amount=element.ui_amount
                if (address==this.npcDialog.sellToken){
                  sellQuantity=amount;
                }
                else if (address==this.npcDialog.purchaseToken){
                  this.coinsEarned=amount;
                }
                  
              });
              if (sellQuantity>0){
                this._companyService.getNpcDialog(this._appData.npc.npcId).collection('container').get().then(val=>{
                  let npcItens=[]
                  let idx=0;
                  val.forEach(npcIt=>{
                    let it=new ItemBean();
                    it.parse(npcIt.data());
                    if (sellQuantity>0){
                      this.list[idx]=it
                      sellQuantity--;
                      idx++;
                    }
                  })
                })
              }
            })
          }
        })
      }

     }
     constructor( public _sanitizer: DomSanitizer,public translate: TranslationService,public _appData : AppDataService,public _companyService : CompanyService,public _auth : UserService,public _walletService : WalletService) {
       super(_sanitizer,translate,_appData, _companyService,_walletService);
     }
 
     



 
 
 



 }


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/vendor/vendor-modal.ts